









import { Vue, Component } from 'vue-property-decorator';
import ConfigurarPantallaTransbank from './ConfigurarPantallaTransbank.vue';
@Component({
  components: { ConfigurarPantallaTransbank },
})
export default class MantenedorTransbankPantalla extends Vue {}
